module.exports = __webpack_public_path__ + "static/media/sohanphoto.23c0a36e.png";